import { render } from "./Index-home.vue?vue&type=template&id=12944b7c"
import script from "./Index-home.vue?vue&type=script&lang=js"
export * from "./Index-home.vue?vue&type=script&lang=js"

import "./Index-home.vue?vue&type=style&index=0&id=12944b7c&lang=css"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__